'use strict';

var React = require('react');

var SvgMetafieldsMajor = function SvgMetafieldsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.75a2.75 2.75 0 0 1 2.75-2.75h.25a.75.75 0 0 1 0 1.5h-.25c-.69 0-1.25.56-1.25 1.25v2.25a.75.75 0 0 1-.22.53l-.47.47.47.47c.141.14.22.331.22.53v2.25c0 .69.56 1.25 1.25 1.25h.25a.75.75 0 0 1 0 1.5h-.25a2.75 2.75 0 0 1-2.75-2.75v-1.94l-.78-.78a.75.75 0 0 1 0-1.06l.78-.78v-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13.25a2.75 2.75 0 0 1-2.75 2.75h-.25a.75.75 0 0 1 0-1.5h.25c.69 0 1.25-.56 1.25-1.25v-2.25a.75.75 0 0 1 .22-.53l.47-.47-.47-.47a.75.75 0 0 1-.22-.53v-2.25c0-.69-.56-1.25-1.25-1.25h-.25a.75.75 0 0 1 0-1.5h.25a2.75 2.75 0 0 1 2.75 2.75v1.94l.78.78a.75.75 0 0 1 0 1.06l-.78.78v1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.913 6.101a.75.75 0 1 0-1.326-.702l-4.5 8.5a.75.75 0 0 0 1.326.702l4.5-8.5Z"
  }));
};
SvgMetafieldsMajor.displayName = "MetafieldsMajor";

exports.SvgMetafieldsMajor = SvgMetafieldsMajor;
